import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n); // 全局挂载

export const i18n = new VueI18n({
  // locale: localStorage.getItem("hoc_locale") || "en", // 从localStorage中获取 默认英文
  // messages: {
  //   kr: require("./lan/kr"), // 韩文语言包
  //   jp: require("./lan/jp"), // 日文语言包
  //   fr: require("./lan/fr"), // fr语言包
  //   de: require("./lan/de"), // de语言包
  //   en: require("./lan/en") // 英文语言包
  // }
});

export default i18n;


// WEBPACK FOOTER //
// ./src/i18n/index.js